import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-not-config',
  standalone: true,
  templateUrl: './not-config.page.html',
  styleUrl: './not-config.page.scss',
})
export class NotConfigPage {
  @Input() statusCode: number | null = null;
  @Input() message: string =
    'La configuración del cliente no se pudo cargar. Por favor, verifica que estás accediendo al subdominio correcto o contacta al soporte.';
  year = new Date().getFullYear();

  retry() {
    window.location.reload();
  }

  statusCodeDigits(): string[] {
    const s = this.statusCode?.toString() ?? '000';
    return s.split('');
  }
}
